/*eslint-disable*/
export default hhh_navbar => {
  let $hhh_navbar = $(hhh_navbar)
  if(document.querySelector('body').classList.contains('template-article')){
    let article_href = window.location.pathname.split('magazine/')[1]
    $hhh_navbar.find(`.js-nav-category[data-magazine-href=${article_href}]`).addClass('selected')
    $hhh_navbar.find('.js-nav-category').each((idxr,chapter)=>$(chapter).click((e)=> window.location.href = ($(e.target).data('magazine-href'))))
  } 
}


// WEBPACK FOOTER //
// ./src/scripts/components/hhh-nav-selection.js